import "./Breadcrumbs.scss";
import { BreadcrumbsProps } from "/Models/Generated/BreadcrumbsProps";
import BreadcrumbItem from "../BreadcrumbItem/BreadcrumbItem";
import {
  BreadcrumbsPopOver,
  GridPresetWideContent,
  GridRow,
} from "/App.Components";
import { BreadcrumbsTheme } from "/Models/Generated/BreadcrumbsTheme";
import { createSpreadableBem } from "/Helpers/createBem";
import { useRef, useState } from "react";
import useClickOutsideElement from "/Helpers/Hooks/useClickOutsideElement";

const Breadcrumbs = ({
  breadcrumbs,
  truncatedBreadcrumbs,
  ariaLabel,
  theme,
  showHiddenBreadcrumbsAriaLabel,
  hiddenBreadcrumbsAriaLabel,
}: BreadcrumbsProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const bem = createSpreadableBem("breadcrumbs-norad");

  const openPopover = () => setIsPopoverOpen(true);
  const closePopover = () => setIsPopoverOpen(false);
  const popOverRef = useRef<HTMLDivElement>(null);

  useClickOutsideElement(closePopover, [popOverRef]);
  const lastBreadcrumbIndex = breadcrumbs.length - 1;

  return (
    <nav
      {...bem("", {
        "--primary": theme === BreadcrumbsTheme.Primary,
        "--secondary": theme === BreadcrumbsTheme.Secondary,
        "--tertiary": theme === BreadcrumbsTheme.Tertiary,
        "--insight": theme === BreadcrumbsTheme.Insight,
      })}
      aria-label={ariaLabel}
    >
      <GridRow>
        <GridPresetWideContent>
          <ul className="breadcrumbs-norad__list">
            <li className="breadcrumbs-norad__list-item breadcrumbs-norad__list-item--mobile">
              <BreadcrumbItem
                {...breadcrumbs[0]}
                isMobile
                theme={
                  theme === BreadcrumbsTheme.Insight ? "insight" : "default"
                }
              />
            </li>
            <li className="breadcrumbs-norad__list-item breadcrumbs-norad__list-item--desktop">
              <BreadcrumbItem
                {...breadcrumbs[0]}
                theme={
                  theme === BreadcrumbsTheme.Insight ? "insight" : "default"
                }
              />
            </li>
            {truncatedBreadcrumbs && truncatedBreadcrumbs.length > 0 && (
              <li className="breadcrumbs-norad__list-item breadcrumbs-norad__list-item--desktop">
                <BreadcrumbItem
                  isEllipsis
                  onEllipsisClick={openPopover}
                  ellipsisAriaLabel={showHiddenBreadcrumbsAriaLabel}
                  theme={
                    theme === BreadcrumbsTheme.Insight ? "insight" : "default"
                  }
                />
                {isPopoverOpen && (
                  <BreadcrumbsPopOver
                    truncatedBreadcrumbs={truncatedBreadcrumbs}
                    theme={
                      theme === BreadcrumbsTheme.Insight ? "insight" : "default"
                    }
                    ref={popOverRef}
                    ariaLabel={hiddenBreadcrumbsAriaLabel}
                  />
                )}
              </li>
            )}
            {breadcrumbs?.slice(1).map((breadcrumb, idx) => (
              <li
                key={breadcrumb.link + idx.toString()}
                className="breadcrumbs-norad__list-item breadcrumbs-norad__list-item--desktop"
              >
                <BreadcrumbItem
                  {...breadcrumb}
                  theme={
                    theme === BreadcrumbsTheme.Insight ? "insight" : "default"
                  }
                  noArrow={idx === lastBreadcrumbIndex - 1}
                />
              </li>
            ))}
          </ul>
        </GridPresetWideContent>
      </GridRow>
    </nav>
  );
};

export default Breadcrumbs;
